var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof LiquidSpaceEmbedded !== "undefined") return resolve();
	__webpack_require__.l("/content/dist/js/embedded-client.js?h=1849d48a54e812c2a56980396481937827a82aca569bff099c0992c6f37c1ff2", (event) => {
		if(typeof LiquidSpaceEmbedded !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "LiquidSpaceEmbedded");
}).then(() => (LiquidSpaceEmbedded));